import CardCommon from '@op/components/CardCommon';
import React from 'react';
import {
  MonitorSelectType,
  TopicType,
} from '@op/components/FilterCommon/types';
import CommonText from './CommonText';
import PreviewMirror from './PreviewMirror';
import FilterInfo from './FilterInfo';
import ChannelShow from './ChannelShow';
import { ComponentKeys } from '../constants';

const componentMap = {
  CommonText,
  PreviewMirror,
  FilterInfo,
  ChannelShow,
};

export default function MonitoringScopeItem({
  filterProps,
  title,
  description,
}: {
  filterProps: MonitorSelectType | TopicType;
  title: string;
  description: Array<{
    component: ComponentKeys;
    filterProps?: any;
    [key: string]: any;
  }>;
}) {
  return (
    <CardCommon title={title} className="dbo-monitoring-scope-card">
      {description.map((item, index) => {
        let { component, filterProps: filter, ...props } = item;
        const Component = componentMap[component];

        if (filterProps) {
          filterProps = {
            ...filterProps,
            ...filter,
          };
        }

        return (
          <Component
            key={index}
            filterProps={filterProps}
            {...props}
          ></Component>
        );
      })}
    </CardCommon>
  );
}
